// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"413":"container","709":"calendar","791":"video"}[chunkId] || chunkId) + "." + {"297":"decade5c","413":"058c8e5d","709":"a75ca7d2","791":"058c8e5d"}[chunkId] + ".chunk.css";
};